module.exports = __webpack_public_path__ + "img/3.7e3fb881.jpg";